import { Button, Col, Form, Input, Row, Select, message, Checkbox } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { useEditUserMutation } from './mutation'
import { useQueryClient } from '@tanstack/react-query'
import { useUserQuery } from './query'
import { useNavigate, useParams } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import { showErrors } from '~/utils/helpers'
import { useSoftwaresQuery } from '~/pages/query'

export const EditUser = () => {
  const { id } = useParams()
  const [form] = Form.useForm()
  const history = useNavigate()
  const queryClient = useQueryClient()
  const { data: user } = useUserQuery(id)
  const { data: softwares } = useSoftwaresQuery()
  const { mutate, isLoading } = useEditUserMutation()
  const [changePassword, setChangePassword] = useState(false)

  useEffect(() => {
    form.setFieldsValue({
      ...user,
      softwares: user?.softwares.map(({ id }) => (id))
    })
  }, [form, user])

  const editUser = useCallback(
    (values) => {
      mutate(
        { ...values, id },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] })
            message.success('User updated successfully')
            history('/admin/users')
          },
          onError: (e) => {
            showErrors(e)
          }
        }
      )
    },
    [mutate, queryClient, history, id]
  )

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title="Edit user"
        onBack={() => window.history.back()}
      />
      <Form
        layout="vertical"
        form={form}
        onFinish={editUser}
      >
        <Row gutter={[48, 8]}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: 'Please enter name' }]}
            >
              <Input placeholder="Please enter name" />
            </Form.Item>

            <Form.Item
              name="softwares"
              label="Softwares"
            >
              <Select
                placeholder="Please select softwares"
                mode="multiple"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const value = option?.children || ''
                  return value.toLowerCase().includes(input.toLowerCase())
                }}
                allowClear
              >
                {softwares?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: 'Please enter email' }]}
            >
              <Input type="email" placeholder="Please enter email" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginBottom: 20 }}>
          <Col span={24}>
            <Checkbox
              checked={changePassword}
              onChange={(e) => {
                if (e.target.checked) {
                  setChangePassword(true)
                } else {
                  setChangePassword(false)
                }
              }}
            >
              Change password?
            </Checkbox>
          </Col>
        </Row>
        {changePassword
          ? (
            <Row gutter={[48, 8]}>
              <Col span={12}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: true, message: 'Please enter password' }]}
                >
                  <Input.Password placeholder="Please enter password" />
                </Form.Item>

                <Form.Item
                  name="password_confirmation"
                  label="Confirm password"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter confirm password'
                    },
                    ({ getFieldValue }) => ({
                      validator (_, value) {
                        if (
                          !value ||
                          getFieldValue('password') === value
                        ) {
                          return Promise.resolve()
                        }
                        return Promise.reject(
                          new Error("Password and Confirm password don't match")
                        )
                      }
                    })
                  ]}
                >
                  <Input.Password placeholder="Please enter cofirm password" />
                </Form.Item>
              </Col>
            </Row>
            )
          : (
              ''
            )}

        <Row gutter={16}>
          <Col span={24}>
            <Button type="primary" htmlType="submit" loading={isLoading} disabled={isLoading}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}
